<script>
  import { Link } from 'svelte-routing'
  import { APP_LIST } from './appList'

  let isMenuActive = false

  // Svelte RoutingのLinkコンポーネントにクラスを付けるためのファンクション
  const getProps = () => ({ class: 'navbar-item' })
</script>

<nav class="navbar is-primary" aria-label="main navigation">
  <div class="navbar-brand">
    <div class="navbar-item">福田興業 社内システム</div>
    <button
      class="navbar-burger"
      class:is-active={isMenuActive}
      aria-label="menu"
      aria-expanded="false"
      data-target="navbarBasicExample"
      on:click={() => (isMenuActive = !isMenuActive)}
    >
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
    </button>
  </div>

  <div class="navbar-menu" class:is-active={isMenuActive}>
    <div class="navbar-start">
      {#each APP_LIST as { path: to, label, isSecret }}
        {#if !isSecret}
          <Link {to} {getProps}>【{label}】</Link>
        {/if}
      {/each}
    </div>
  </div>
</nav>
